import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';

export interface IVendorDocumentsState {
  documents: { [orderId: string]: IStandardDocumentVersionData[] };
  documentsFetchStatus: IFetchStatus;
  documentsError?: string;
  uploadDocumentsFetchStatus: IFetchStatus;
  uploadDocumentsError?: string;
  deleteDocumentsFetchStatus: IFetchStatus;
  deleteDocumentsError?: string;
}

export const vendorDocumentsInitialState: IVendorDocumentsState = {
  documents: {},
  documentsFetchStatus: createDefaultFetch(),
  uploadDocumentsFetchStatus: createDefaultFetch(),
  deleteDocumentsFetchStatus: createDefaultFetch(),
};
